import React from "react";
import { setInfoKey } from '../../api/information-collection/actions'
import { Tooltip,calculateContractlength, getContractStartDate, getPersonAgeByContractDate } from '../../utils'
import CurrencyFormat from 'react-currency-format';
import StartDateOptions from '../start-date-options'
import InsuranceTaker from '../insurance-taker'

const kennitala = require('kennitala')

class KspForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            errors: {
                age: '',
                ageContractEnd: '',
                monthlyinsurance: '',
                onepayment: '',
            }
        }

        this.onChangeCheckbox = this.onChangeCheckbox.bind(this)
        this.onChangeTextInput = this.onChangeTextInput.bind(this)
        this.onChangeSelectValue = this.onChangeSelectValue.bind(this)
        this.onClickChange = this.onClickChange.bind(this)
        this.onClickConfirm = this.onClickConfirm.bind(this)
        this.age = React.createRef()
        this.ageContractEnd = React.createRef()
        this.monthlyinsurance = React.createRef()
        this.onepayment = React.createRef()
    }

    componentDidMount () {
        if (this.props.initialValues['KSPcontractstartdate'] === undefined) {
            this.props.dispatch(setInfoKey({key: "KSPcontractstartdate", value: getContractStartDate("KSP").format("D.M.YYYY")}, this.props.customerId))
        }

        let info = kennitala.info(this.props.customerId)
        if (info.age > 17) {
            this.props.dispatch(setInfoKey({key: "KSPinsuranceTaker", value: this.props.customerId}, this.props.customerId))
        }

    }
    
    validateForm() {
        let errors = this.state.errors
        let valid = true;
        Object.keys(errors).forEach(key => {
            switch (key) {
                case 'age':
                    let ageValue = this.props.initialValues["age"];
                    if (parseInt(ageValue) < 18) {
                        errors.age = 'Að lágmarki 18'
                        valid = false;
                    } else if (parseInt(ageValue) > 66) {
                        errors.age = 'Að hámarki 66'
                        valid = false;
                    } else {
                        errors.age = ''
                    }
                    break;
                case 'ageContractEnd':
                    let ageContractEndValue = this.ageContractEnd.current.value;
                    let contractLength = calculateContractlength(this.props.customerId, ageContractEndValue, this.props.initialValues["KSPcontractstartdate"], "KSP")

                    if (contractLength < 5 && parseInt(ageContractEndValue) > 0) {
                        errors.ageContractEnd = 'Samningur að lágmarki 5 ár'
                        valid = false;
                    } else if (ageContractEndValue === '') {
                        errors.ageContractEnd = 'Skilyrði að fylla út'
                        valid = false;
                    } else {
                        errors.ageContractEnd = ''
                    }
                    break;

                case 'monthlyinsurance':
                        let monthlyinsuranceValue = this.props.initialValues["KSPpayment"];
                    if (this.props.initialValues["KSPtype"] === "insuranceamount") {
                        if (parseInt(monthlyinsuranceValue) > 5000) {
                            errors.monthlyinsurance = 'Að hámarki 5.000 €'
                            valid = false;
                        } else if (parseInt(monthlyinsuranceValue) < 50) {
                            errors.monthlyinsurance = 'Að lágmarki er 50 €'
                            valid = false;
                        } else if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    } else {
                        if (monthlyinsuranceValue === '' || monthlyinsuranceValue == undefined) {
                            errors.monthlyinsurance = 'Skilyrði að fylla út';
                            valid = false
                        } else {
                            errors.monthlyinsurance = ''
                        }
                    }
                    break;
                case 'insurancetaker':
                    let insuranceTakerValue = this.props.initialValues['KSPinsuranceTaker'];
                    if (insuranceTakerValue === undefined || insuranceTakerValue === "") {
                        errors.insurancetaker = 'Velja þarf tryggingartaka'
                        valid = false;
                    } else {
                        errors.insurancetaker = ''
                    }
                    break;
                default:
                    break;

            }
        });
        this.setState({ errors: errors })
        return valid;
    }

    onChangeCheckbox(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeTextInput(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }

    onChangeLargeNumberInput(value, name) {
        this.props.dispatch(setInfoKey({ key: name, value: value }, this.props.customerId))
    }
    
    onChangeSelectValue(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: event.target.value }, this.props.customerId))
    }
    onClickConfirm(event) {
        let validate = this.validateForm()
        
        if (this.props.isAdult && this.props.initialValues['KSPinsuranceTaker'] === undefined) {
            this.props.dispatch(setInfoKey({ key: 'KSPinsuranceTaker', value: this.props.customerId }, this.props.customerId))
        }

        if (validate) {
            Promise.resolve(this.props.dispatch(setInfoKey({ key: event.target.name, value: true }, this.props.customerId)))
                .then(() => {
                    this.props.onSuccess()
                })
        }
    }
    onClickChange(event) {
        this.props.dispatch(setInfoKey({ key: event.target.name, value: false }, this.props.customerId))
    }

    render() {
        const { customerId, customers, active, initialValues } = this.props
        const contractAge = getPersonAgeByContractDate(customerId, initialValues["KSPcontractstartdate"])
        const displayAge = contractAge !== null ? contractAge : initialValues["age"]

        return (
            <>
                <form className="contract-form">
                    <div className={`${this.state.errors.age.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ksp-contract-age-${customerId}`} className="col-sm-8 col-form-label">
                            Samningsaldur
                            {this.state.errors.age.length > 0 ?
                                 <span className="error"> ({this.state.errors.age}) </span> : ''
                            }
                            <Tooltip placement="bottom" text={"Samningsaldur umsækjanda miðast við upphafsdag samnings.  Ef <strong>meira en 183 dagar</strong> eru liðnir frá síðasta afmæli á upphafsdegi er aldurinn námundaður upp um eitt ár."} />
                        </label>
                        <div className="col-sm-4">
                            <input id={`ksp-contract-age-${customerId}`} name="contract-age" type="number" className="form-control px-2 text-sm-right" value={displayAge} disabled />
                            <input type="hidden" ref={this.age} id={`ksp-age-${customerId}`} name="age" className="form-control px-2 text-sm-right" value={initialValues["age"]}/>
                        </div>
                    </div>
                    <div className={`form-row align-items-center`}>
                        <label className="col-sm-8 col-form-label">
                            Upphaf samnings
                        </label>
                        <div className="col-sm-4 text-right">
                            <StartDateOptions
                                startDate={getContractStartDate("KSP").format("D.M.YYYY")}
                                selectedDate={initialValues["KSPcontractstartdate"]}
                                contractDateKey={"KSPcontractstartdate"}
                                customerId={customerId}
                                disabled={initialValues.kspConfirm}
                                dispatch={this.props.dispatch}
                            />
                        </div>
                    </div>
                    <div className={`${this.state.errors.ageContractEnd.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <label htmlFor={`ksp-age-by-contract-end-${customerId}`} className="col-sm-8 col-form-label">
                            Aldur við lok samnings
                            {this.state.errors.ageContractEnd.length > 0 ?
                                 <span className="error"> ({this.state.errors.ageContractEnd}) </span> : ''
                            }
                        </label>
                        <div className="col-sm-4">
                            <input ref={this.ageContractEnd} id={`ksp-age-by-contract-end-${customerId}`} name="KSPageByContractEnd" type="number" className="form-control px-2 text-sm-right" onChange={this.onChangeTextInput} value={initialValues["KSPageByContractEnd"]} disabled={initialValues.kspConfirm} />
                        </div>
                    </div>
                    <div className="form-row align-items-center">
                        <label htmlFor={`ksp-contract-length-${customerId}`} className="col-sm-8 col-form-label">Lengd samnings (ár)</label>
                        <div className="col-sm-4">
                            <input id={`ksp-contract-length-${customerId}`} type="number" className="form-control px-2 text-sm-right" onChange={this.onChangeTextInput} value={calculateContractlength(customerId, initialValues["KSPageByContractEnd"], initialValues["KSPcontractstartdate"], "KSP")} disabled />
                        </div>
                    </div>
                    <div className={`${this.state.errors.monthlyinsurance.length > 0 ? 'error' : ''} form-row align-items-center`}>
                        <div className="col-sm-8">
                            <select className="custom-select col-sm-4" id={`ksp-type-${customerId}`} name="KSPtype" onChange={this.onChangeSelectValue} value={initialValues["KSPtype"]} disabled={initialValues.kspConfirm} >
                                <option value="monthly">Iðgjald</option>
                                <option value="insuranceamount">Tekjulífeyrir</option>
                            </select>
                            {this.state.errors.monthlyinsurance.length > 0 ?
                                 <span className="error"> ({this.state.errors.monthlyinsurance}) </span> : ''
                            }
                        </div>

                        <div className="col-12 col-sm-4 currency">
                            <CurrencyFormat
                                    ref={this.monthlyinsurance}
                                    thousandSeparator={"."} 
                                    id={`ksp-payment-${customerId}`}
                                    name="KSPpayment"
                                    type="text" 
                                    className="form-control text-sm-right pr-4"                                 
                                    value={initialValues["KSPpayment"]} 
                                    disabled={initialValues.kspConfirm} 
                                    decimalSeparator={','} 
                                    onValueChange={(values) => {
                                        const {value} = values;
                                        this.onChangeLargeNumberInput(value, "KSPpayment")
                                    }}
                                />
                            {initialValues["KSPtype"] === "insuranceamount" && <div>50-5.000€</div>}

                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-6 col-form-label">Eingreiðsla við alvarlega sjúkdóma</div>
                        <div className="col-sm-6 text-right smoker">
                            <input type="radio" id={`KSPdiseasepayment-100${customerId}`} name="KSPdiseasepayment" onClick={this.onChangeCheckbox} defaultChecked={initialValues.KSPdiseasepayment == "100"} value={"100"} disabled={initialValues.kspConfirm} />
                            <label htmlFor={`KSPdiseasepayment-100${customerId}`} className="col-sm-4 col-form-label">100%</label>
                            <input type="radio" id={`KSPdiseasepayment-200${customerId}`} name="KSPdiseasepayment" onClick={this.onChangeCheckbox} defaultChecked={initialValues.KSPdiseasepayment == "200"} value={"200"} disabled={initialValues.kspConfirm} />
                            <label htmlFor={`KSPdiseasepayment-200${customerId}`} className="col-sm-4 col-form-label">200%</label>
                        </div>
                    </div>

                    <div className="form-row align-items-center">
                        <div className="col-sm-8">
                            <label htmlFor={`ksp-payment-frequency-${customerId}`} className="col-sm-8 col-form-label pl-0">Greiðslutíðni</label>
                        </div>
                        <div className="col-sm-4 text-right">
                            <select className="custom-select col-sm-4" id={`ksp-payment-frequency-${customerId}`} name="KSPpaymentfrequency" onChange={this.onChangeSelectValue} value={initialValues["KSPpaymentfrequency"]} disabled={initialValues.kspConfirm}>
                                <option value="monthly">Mánaðarlega</option>
                                <option value="quarterly">Ársfjórðungslega</option>
                                <option value="every6months">Hálfsárslega</option>
                                <option value="yearly">Árlega</option>
                               
                            </select>
                        </div>
                    </div>
                    <InsuranceTaker fieldName={`KSPinsuranceTaker`} customerId={customerId} customers={customers} initialValues={initialValues} disabled={initialValues.kspConfirm} />
                </form>
                <div className="col-12 text-right button-container">
                    {initialValues.kspConfirm ?
                        (<button className="btn btn-primary xs-m-10" name="kspConfirm" onClick={this.onClickChange}> Breyta </button>) :
                        (<button className="confirm-btn btn btn-primary xs-m-10" name="kspConfirm" onClick={this.onClickConfirm}> Staðfesta </button>)}
                </div>
            </>
        )
    }
}

export default KspForm